// extracted by mini-css-extract-plugin
export var quantityInput = "_ol-0";